module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/news/would-you-netflix-your-next-car/"},"frontmatter":{"title":"Would you Netflix your next car?","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450-netflix-and-drive-header-image-v1-0797953922f54f10b1c7e702c2d78c4b.jpg"}}},"original":"/img/1160x450-netflix-and-drive-header-image-v1.jpg"},"category":"Culture"}}}]}},"pathContext":{"tag":"netflix"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-netflix.json
// module id = 1823
// module chunks = 68262445049343